import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import themeVars from 'ui_theme/site/globals/site.variables'

import { runOnNextTick, propFunc } from 'util/functions'

import SpacedItems from 'shared/components/ui/SpacedItems'

const truncateStyle = css`
  overflow: hidden;
  white-space: nowrap;
`

const subjectStyle = ({ theme }) => css`
  color: ${theme.color.monochrome.superDark};
  font-family: ${themeVars.pageFont};
  font-weight: ${themeVars.pageFontWeightSemiBold};
`

const StyledLargerSubject = styled('div')`
  ${truncateStyle}
  ${subjectStyle}
  font-size: ${themeVars['21px']};

  @media print {
    overflow: visible;
    white-space: normal;
  }
`
const StyledSmallerSubject = styled('div')`
  ${subjectStyle}
  font-size: ${props => props.theme.spacing['10']};
`
const PrintableTicketNumber = styled('div')`
  font-size: ${props => props.theme.spacing['10']};
`

export default class EditableSubjectNormalState extends React.Component {
  state = {}

  componentDidMount() {
    this.runCheckOverflow()
    window.addEventListener('resize', this.runCheckOverflow)
  }

  componentDidUpdate(prevProps) {
    if (this.props.ticket.title !== prevProps.ticket.title) {
      // pnagy: here we explicitly want to make sure that we'll
      // remasure the size of the subject text.
      // eslint-disable-next-line react/no-did-update-set-state
      runOnNextTick(this.setNotOverflown)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.runCheckOverflow)
  }
  // pnagy: In this component we have an editable subject.
  // This method checks whether the subject is overflowing and
  // needs to be truncated. When it does we'll decrease the font
  // size and let it break into multiple lines. To do this we need
  // to store if the content fits its box or not

  setNotOverflown = () => {
    this.setState({ hasOverflow: false })
  }

  runCheckOverflow = () => {
    if (this.timeout) clearTimeout(this.timeout)
    this.timeout = runOnNextTick(this.checkOverflow)
  }

  checkOverflow = () => {
    if (!this.title) return
    const isOverflown = this.title.scrollWidth !== this.title.offsetWidth
    if (isOverflown && this.state.hasOverflow !== isOverflown) {
      this.setState({ hasOverflow: isOverflown })
    }
  }

  takeRef = node => {
    this.title = node && node.firstChild
    this.runCheckOverflow()
  }

  render() {
    const { ticket, doStartEditingTicketTitle } = this.props
    const { hasOverflow } = this.state
    return (
      <SpacedItems.Container
        verticalAlign="center"
        horizontalAlign="center"
        gap="mini"
      >
        <SpacedItems.Item
          className="fullstack-ticket-title"
          grow={1}
          css={css`
            min-width: 0;
          `}
        >
          {!hasOverflow && (
            <div ref={this.takeRef}>
              <StyledLargerSubject
                onClick={propFunc(
                  doStartEditingTicketTitle,
                  ticket.id,
                  ticket.title
                )}
              >
                {ticket.title || 'Add Subject'}
              </StyledLargerSubject>
            </div>
          )}
          {hasOverflow && (
            <StyledSmallerSubject
              onClick={propFunc(
                doStartEditingTicketTitle,
                ticket.id,
                ticket.title
              )}
            >
              {ticket.title || 'Add Subject'}
            </StyledSmallerSubject>
          )}
        </SpacedItems.Item>
        <SpacedItems.Item className="visible-only-in-print">
          <PrintableTicketNumber>#{ticket.id}</PrintableTicketNumber>
        </SpacedItems.Item>
      </SpacedItems.Container>
    )
  }
}
